export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.17-1456.44",
  commitId: "0cab574274e1adb55aa5eb754011746beafbe414",
  commitTime: "2026-07-17T14:56:44.000Z",
});
